import React from 'react'
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const PrivacyPolicy = () => {
	const allPagesContent = useSelector((state) => state.pages.pages)
    const privacyContent = allPagesContent.find((page) => page.slug === 'privacy-policy')
	const isPageLoading = useSelector((state) => state.pages.isLoading)
	return (
		isPageLoading ?
			<div className='spinner-wrapper'> 
				<Spinner animation="border" variant="info" />
			</div>
		:
		<div className='main-text-section'>
			<Container>
				<Row>
					<Col>
						<h2>Privacy Policy</h2>
						<div dangerouslySetInnerHTML={{ __html: privacyContent?.content?.rendered }}></div>
					</Col>
				</Row>
			</Container>
		</div>
	)
}

export default PrivacyPolicy